<template>
  <div>
    <label v-if="label" :for="name">{{ label }}</label>
    <div :class="{ 'input-group': addon }">
      <select
        class="form-control"
        :class="[classObject, classname]"
        :name="name"
        :id="name"
        :value="value"
        :disabled="disabled"
        v-on:change="updateValue($event.target.value)"
        ref="select"
      >
        <option v-if="empty" value="">Kies {{ label }}</option>
        <option v-for="option in options" :key="option.name" :value="option.value" :selected="option.value == value">{{ option.name }}</option>
      </select>
      <div class="input-group-append" v-if="addon">
        <span class="input-group-text">
          {{ addon }}

          <i
            v-if="addonTooltip"
            class="fas fa-question-circle ml-2"
            data-toggle="tooltip"
            data-placement="top"
            :title="addonTooltip"
            :data-original-title="addonTooltip"
          ></i>
        </span>
      </div>
      <small v-if="helper" class="form-text text-muted">{{ helper }}</small>
      <div v-if="error" class="invalid-feedback animated fadeIn">{{ error | capitalize }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    classname: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    value: {},
    disabled: {
      type: Boolean,
    },
    label: {
      type: String,
    },
    helper: {
      type: String,
    },
    select2: {
      type: Boolean,
      default: true,
    },
    empty: {
      type: Boolean,
      default: true,
    },
    addon: {
      type: String,
    },
    addonTooltip: {
      type: String,
    },
    errorOnTouch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      error: null,
    };
  },
  watch: {
    value: function(val, oldVal) {
      $(this.$refs.select)
        .val(!val ? '' : val)
        .trigger('change');
    },
    addon: function() {
      setTimeout(() => {
        window.One.helpers(['core-bootstrap-tooltip']);
      }, 100);
    },
    '$parent.errors': {
      immediate: true,
      deep: true,
      handler: function(errors) {
        if (errors && errors.hasOwnProperty(this.name) && errors[this.name].length > 0) {
          this.error = errors[this.name][0].replace(':field', this.label ? this.label.toLowerCase() : this.name);
        }
      },
    },
  },
  computed: {
    classObject: function() {
      return {
        'is-invalid': this.error ? true : false,
        'select2-hidden-accessible': this.select2,
      };
    },
  },
  methods: {
    updateValue: function(value) {
      if (this.errorOnTouch) {
        this.error = null;
      }
      this.$emit('input', value);
    },
  },
};
</script>
